import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
`;

export const Button = styled.button`
  cursor: pointer;
  background: inherit;
  border: 1px solid;
  border-radius: 5px;
  height: 30px;
  color: white;
  margin: 0 25px;
`;
